export interface Props {
  selectedTab?: number;
}

export const dependencies: string[][] = [
  ['Axios', '1.6.1', 'MIT'],
  ['Axios-jsonp', '1.0.4', 'ISC'],
  ['Dequal', '2.0.3', 'MIT'],
  ['Detect-browser', '5.3.0', 'MIT'],
  ['Dotenv', '16.3.1', 'BSD-2-Clause'],
  ['Jest-styled-components', '7.2.0', 'MIT'],
  ['Jotai', '2.7.2', 'MIT'],
  ['Mobx', '6.12.3', 'MIT'],
  ['Mobx-react', '9.1.1', 'MIT'],
  ['Mobx-react-lite', '4.0.7', 'MIT'],
  ['Norigin-spatial-navigation', '2.1.0', 'MIT'],
  ['React', '18.2.0', 'MIT'],
  ['React-beautiful-dnd', '13.1.1', 'Apache-2.0'],
  ['React-dom', '18.2.0', 'MIT'],
  ['React-helmet', '6.1.0', 'MIT'],
  ['React-lazy-load-image-component', '1.6.2', 'MIT'],
  ['React-router-dom', '6.18.0', 'MIT'],
  ['React-transition-group', '4.4.5', 'BSD-2-Clause'],
  ['Reset-css', '5.0.2', 'Public Domain'],
  ['Sentry/react', '7.80.0', 'MIT'],
  ['webOSTV.js', '1.2.13', 'Apache-2.0']
];

export const displayDeviceSpecs = process.env.DISPLAY_SPECS === 'true';
